import React from 'react';

const LoadingComponent = () => {
  return (
     <div>
        <div className="w-full h-[calc(100vh-100px)] flex flex-col items-center justify-center">
          <p className="flex text-gray-500 text-md">
            <span className="flex">
              <span className="animate-bounce">L</span>
              <span className="animate-bounce [animation-delay:0.15s]">O</span>
              <span className="animate-bounce [animation-delay:0.3s]">A</span>
              <span className="animate-bounce [animation-delay:0.3s]">D</span>
              <span className="animate-bounce [animation-delay:0.5s]">I</span>
              <span className="animate-bounce [animation-delay:0.7s]">N</span>
              <span className="animate-bounce [animation-delay:0.9s]">G</span>
            </span>
          </p>
          <p className="text-gray-500 text-sm">If it takes a while you may want to refresh page</p>
        </div>
      </div>
  );
};

export default LoadingComponent;
